// extracted by mini-css-extract-plugin
export default {"rating":"YB-z","numberOfStars":"ZB-z","count":"_B-z","barGraphSpacing":"aC-z","barGraph":"bC-z"};